import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration for MSAL authentication
 */
export const msalConfig = {
  auth: {
    clientId: '', // Will be populated from runtime config
    authority: '', // Will be populated from runtime config
    redirectUri: `${window.location.origin}/login-callback`,
    postLogoutRedirectUri: `${window.location.origin}`,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
};

/**
 * Authentication request configuration
 */
export const authRequest = {
  scopes: ['openid', 'profile', 'email']
};

/**
 * B2C authentication configuration
 */
export const b2cConfig = {
  // Will be populated from runtime config
  tenantName: '',
  clientId: '',
  policy: '',
  authorityDomain: 'b2clogin.com',
  scopes: ['openid', 'profile', 'email']
};

/**
 * Build the B2C authority URL
 * 
 * @param tenant The B2C tenant name
 * @param policy The B2C policy/user flow name
 * @returns The full authority URL
 */
export function buildB2CAuthorityUrl(tenant: string, policy: string): string {
  return `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/${policy}`;
}

/**
 * Build the Entra ID authority URL
 * 
 * @param tenantId The Azure AD tenant ID
 * @returns The full authority URL
 */
export function buildEntraAuthorityUrl(tenantId: string): string {
  return `https://login.microsoftonline.com/${tenantId}`;
}
